import { render, staticRenderFns } from "./ProducerDetails.vue?vue&type=template&id=4b159dc6"
import script from "./ProducerDetails.vue?vue&type=script&lang=js"
export * from "./ProducerDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b159dc6')) {
      api.createRecord('4b159dc6', component.options)
    } else {
      api.reload('4b159dc6', component.options)
    }
    module.hot.accept("./ProducerDetails.vue?vue&type=template&id=4b159dc6", function () {
      api.rerender('4b159dc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/ProducerDetails.vue"
export default component.exports